export default __webpack_public_path__ + "static/media/news.d5e651e4.png";